// Beat-visual event + effect vocabulary.
export const BeatVisualEvent = {
  BEAT: "beat", HALF_BEAT: "half_beat", BAR_START: "bar_start",
  PHRASE_START: "phrase_start", TENSION_PEAK: "tension_peak", RESULT_RESOLVE: "result_resolve",
};

export const VisualEffect = {
  COMPASS_SWAY: "compass_sway",
  MAP_MARKER_PULSE: "map_marker_pulse",
  ROUTE_ILLUMINATION: "route_illumination",
  LANTERN_GLOW: "lantern_glow",
  DANGER_TRANSITION: "danger_transition",
  CARD_REVEAL: "card_reveal",
  RESULT_REVEAL: "result_reveal",
  CEREMONY: "ceremony",
  HALL_GLOW: "hall_glow",
};

export const Intensity = { SUBTLE: "subtle", MODERATE: "moderate", STRONG: "strong" };

// One-time flourishes (deduplicated, share the result/ceremony audio dedup key family).
export const ONE_TIME_EFFECTS = new Set([VisualEffect.RESULT_REVEAL, VisualEffect.CEREMONY, VisualEffect.CARD_REVEAL]);

// Max simultaneous prominent effects: 1 primary + 2 subtle supporting.
export const MAX_PRIMARY = 1;
export const MAX_SUPPORTING = 2;
